import React from 'react';
import './Appointment.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import {AiFillHome} from "react-icons/ai";
import ContactForm from '../../components/ContactForm/ContactForm';

const Appointment = () => {

    const mapLink = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.145831566261!2d75.90956907576795!3d22.759968679358703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39631da97352545b%3A0x72092f895d6577cf!2sDr%20Poonam%20(MDS%20Root%20Canal%20Specialist)%2FBest%20Dental%20Clinic%20in%20Mahalaxmi%20Nagar%2C%20Nipania%2F%20Implant%2F%20Braces%2F%20Crown%20%26%20Bridge!5e0!3m2!1sen!2sin!4v1732605146682!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade'
    return (
        <section className='appointment-section pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <div className="google-map">
                            <iframe title='map' src={mapLink}></iframe>

                            <div className="location-name">
                                <AiFillHome />
                                <p>Mahalaxmi Nagar, Indore</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-6">
                        <div className="appointment-form-area">
                            <SectionTitle 
                            // subTitle="Reach out to us"
                            title="Exceptional Care at Your Dental Clinic"
                            description="Experience state-of-the-art dental treatments in a warm, welcoming environment. Our expert team is dedicated to brightening your smile and ensuring your comfort at every visit."/>

                            <ContactForm />
                          
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Appointment;